module.exports = __webpack_public_path__ + "static/media/Spinner.8d0e167f.gif";